import React from "react";
import { Link } from "react-router-dom";
import { business, LANDING_LINKS } from "./landingContent";

/** קטגוריית HotelsRiver Business בעמוד הבית — מפנה לעמוד ההתחברות של פורטל החברות. */
export default function LandingBusiness() {
  return (
    <section
      className="hr-landing-section hr-landing-business"
      aria-labelledby="hr-landing-business-title"
    >
      <div className="home-page__container">
        <div className="hr-landing-business__card">
          <div className="hr-landing-business__copy">
            <p className="hr-landing-business__eyebrow">{business.eyebrow}</p>
            <h2 id="hr-landing-business-title" className="hr-landing-business__title">
              {business.title}
            </h2>
            <p className="hr-landing-business__text">{business.text}</p>
            <ul className="hr-landing-business__points">
              {business.points.map((point, i) => (
                <li key={i} className="hr-landing-business__point">
                  {point}
                </li>
              ))}
            </ul>
            <div className="hr-landing-business__actions">
              <Link
                to={LANDING_LINKS.companyLogin}
                className="hr-landing-btn hr-landing-btn--primary"
              >
                {business.cta}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
